export function mediaPlayer() {
  return {
    __typename: 'MediaPlayer',
    id: null,
    isPlaying: false,
    playlist: null,
    currentTrack: null,
    isShuffling: false,
    isRepeating: false,
  };
}




// WEBPACK FOOTER //
// ./src/@data/mediaPlayer/queries.js